import Vue from 'vue';
import VueRouter from 'vue-router';

import InternetArtworks from '@/internet_auctions/components/artworks';
import EmployeesAuctionsCatalogsIndex from './../employees/auctions_catalogs/index/components/auctions_catalogs';
import EmployeesFinishedAuctionsCatalogs from './../employees/components/finished_auctions_catalogs';
import FinishedAuctionsCatalog from './../auctions_catalogs/show/components/auctions_catalog';
import ArtworkModal from './components/modal';
import EmployeesFinishedAuctionsCatalog from './../employees/components/finished/auctions_catalog';
import EmployeesFinishedAuctionsCatalogArtworks from './../employees/components/finished/artworks';
import EmployeesFinishedAuctionsCatalogOrders from './../employees/components/finished/orders';
import EmployeesFinishedAuctionsCatalogReportedToBidArtworks from './../employees/components/finished/reported_to_bid_artworks';
import EmployeesPayments from './../employees/components/payments/index';
import EmployeesOrdersPanel from './../employees_orders_panel/components/auctions';
import SearchPage from './../search_page/index/components/search_page';

Vue.use(VueRouter);

const routes = [
  {
    path: '/employees/:auctionType/auctions_catalogs',
    name: 'employeesAuctionsCatalogs',
    component: EmployeesAuctionsCatalogsIndex,
  },
  {
    path: '/employees/:auctionType/finished/auctions_catalogs',
    name: 'employeesFinishedAuctionsCatalogs',
    component: EmployeesFinishedAuctionsCatalogs,
  },
  {
    path: '/employees/:auctionType/finished/auctions_catalogs/:id',
    name: 'EmployeesFinishedAuctionsCatalog',
    component: EmployeesFinishedAuctionsCatalog,
    children: [
      {
        path: 'artworks',
        name: 'employeesFinishedAuctionsCatalogArtworks',
        component: EmployeesFinishedAuctionsCatalogArtworks,
      },
      {
        path: 'orders',
        name: 'employeesFinishedAuctionsCatalogOrders',
        component: EmployeesFinishedAuctionsCatalogOrders,
      },
      {
        path: 'reported_to_bid_artworks',
        name: 'employeesFinishedAuctionsCatalogReportedToBidArtworks',
        component: EmployeesFinishedAuctionsCatalogReportedToBidArtworks,
      },
    ],
  },
  {
    path: '/employees/payments',
    name: 'employeesPayments',
    component: EmployeesPayments,
  },
  { path: '/wyniki-aukcji/:id',
    name: 'finishedAuctionsCatalog',
    component: FinishedAuctionsCatalog,
    children: [
      { path: ':dzielo',
        component: ArtworkModal,
      },
    ],
  },
  {
    path: '/wyszukiwarka',
    name: 'SearchPage',
    component: SearchPage,
  },
  {
    path: '/katalogi-aukcyjne/:auctionName/internet',
    props: true,
    name: 'InternetAuctionCatalogue',
    component: InternetArtworks,
  },
  {
    path: '/employees/internet/auctions_catalogs/:auctionType/orders',
    name: 'EmployeesOrdersPanel',
    component: EmployeesOrdersPanel,
  },
];

export default new VueRouter({
  base: '/',
  mode: 'history',
  routes,
});



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/routes.js